import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    const skip = ["/auth/refresh", "/auth/login", "/auth/logout"].some((p) => (orig.url || "").includes(p));
    if (error.response?.status === 401 && !orig._retry && !skip) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

const FIELD_LABELS = {
  email: "Email", password: "Password", phone: "Telefono", company_name: "Ragione sociale", center_name: "Nome del centro",
  vat_number: "Partita IVA", tax_code: "Codice fiscale", address: "Indirizzo", zip_code: "CAP", city: "Città", province: "Provincia",
  owner_first_name: "Nome del titolare", owner_last_name: "Cognome del titolare", specialists: "Specialist", first_name: "Nome", last_name: "Cognome",
};

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Qualcosa non ha funzionato. Riprova tra un istante.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const field = [...(d[0]?.loc || [])].reverse().find((x) => typeof x === "string" && FIELD_LABELS[x]);
    return field ? `Controlla il campo "${FIELD_LABELS[field]}": il valore inserito non è valido.` : "Controlla i campi inseriti: alcuni dati non sono validi.";
  }
  return String(d.msg || d);
}

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const load = useCallback(async () => {
    if (!path) return;
    setLoading(true);
    try {
      const r = await api.get(path);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => {
    load();
  }, [load]);
  return { data, loading, error, reload: load, setData };
}

export async function getFileUrl(kind, id, download = false) {
  const r = await api.post("/files/link", { kind, id, download });
  return `${BACKEND}${r.data.url}`;
}

export async function downloadFile(kind, id) {
  const url = await getFileUrl(kind, id, true);
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
